import type { FC } from 'react';

import { loadingLineCss, loadingTrackCss } from './LoadingIndicator.styles';

/** Animated loading bar shown while the AI agent is generating a response. */
export const LoadingIndicator: FC = () => (
  <div className={loadingTrackCss}>
    <div className={loadingLineCss} />
  </div>
);

LoadingIndicator.displayName = 'LoadingIndicator';
